import { ref, reactive } from 'vue';
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
//import dayjs from 'dayjs';
import { Post, Get } from '@/api/Api';
import { ls } from 'vue-lsp';
import { ACCESS_TOKEN } from '@/store/mutation-types';
export default {
  name: 'Index',
  components: {},
  setup(props, context) {
    const RefForm = ref();
    const IsShow = ref(false);
    const DMConfig = reactive({
      FId: 0,
      Title: '',
      Width: '0',
      Height: '0',
      loading: false,
      ModelClass: '',
      Model: {},
      DMForm: {
        form: {
          labelCol: {
            style: {
              width: '160px'
            }
          }
        }
      }
    });
    const SubmitForm = e => {
      RefForm.value.validate().then(() => {
        console.log('values11', DMConfig.Model);
        DMConfig.loading = true;
        Post("DM/SavePIAuthorize", DMConfig.Model).then(res => {
          if (res.succeeded) {
            _message.success('保存成功');
            context.emit('ok');
            IsShow.value = false;
          } else {
            _message.error('保存失败：' + res.errors);
            DMConfig.loading = false;
          }
        }).catch(err => {
          _message.error(err.errors);
          DMConfig.loading = false;
        });
      }).catch(error => {
        console.log(error);
        //message.error(error.message);
      });
    };

    const ResetForm = (form, DataSource) => {
      console.log('DataSource');
    };
    const Open = (fId, width, height) => {
      IsShow.value = true;
      DMConfig.loading = true;
      DMConfig.FId = fId;
      DMConfig.Title = (fId == 0 ? '新增' : '修改') + '客户资料';
      DMConfig.Width = width == 0 ? "100%" : width;
      DMConfig.ModelClass = width == 0 ? "full-modal" : "";
      DMConfig.Height = height == 0 ? "100%" : height;
      if (fId > 0) {
        Get("/DM/GetPIAuthorize", {
          id: fId
        }).then(res => {
          DMConfig.Model = res.data;
          DMConfig.loading = false;
        });
      } else {
        DMConfig.Model = {};
        DMConfig.loading = false;
      }
    };
    return {
      IsShow,
      Open,
      RefForm,
      DMConfig,
      SubmitForm,
      ResetForm
    };
  },
  created() {
    console.log('created');
  },
  mounted() {},
  methods: {}
};